import gql from 'graphql-tag';

export const WORKSPACE_MEMBER_FRAGMENT = gql`
  fragment WorkspaceMember on CustomerMember {
    id
    email
    name
    role
  }
`;

export const WORKSPACE_FRAGMENT = gql`
  fragment Workspace on Workspace {
    id
    name
    creator {
      id
      name
      email
    }
    workspaceMembers {
      ...WorkspaceMember
    }
    workspaceMembersCount
    accessType
    defaultForUserIds
    defaultBrandVoice {
      id
    }
  }
  ${WORKSPACE_MEMBER_FRAGMENT}
`;

export const WORKSPACE_ASSOCIATIONS_FRAGMENT = gql`
  fragment WorkspaceAssociations on Workspace {
    associatedBrandVoices {
      id
    }
    defaultBrandVoice {
      id
    }
    visualLanguages {
      id
    }
    defaultVisualLanguage {
      id
    }
    associatedFreestyleTools {
      id
    }
    associatedMultiPromptTemplates {
      id
    }
    associatedResources {
      id
    }
    associatedProjects {
      id
    }
  }
`;

export const WORKSPACE_DEFAULT_TOV_ANALYZER_FOR_TOOL_FRAGMENT = gql`
  fragment WorkspaceDefaultTovAnalyzerForTool on Workspace {
    id
    defaultTovAnalyzerForTool {
      generationTool
      customTovId
      customTovName
    }
  }
`;
